import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import PageHeader from '@common/PageHeader'
import mainStore from '@components/Main/store'
import { RouterView } from '@merchant-backend/common-components'
import { isWeddingDressProperty } from '@merchant-backend/util'
import {
  getAuthIdList,
  getMerchantInfo,
  isEmojiCharacter,
  isSiDaMember
} from '@util'
import 'antd4/lib/grid/style/index.css'
import {
  Alert,
  Carousel,
  Cascader,
  DatePicker,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Tag,
  TreeSelect,
  Upload
} from 'hljd'
import { autorun, toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory, Link } from 'react-router'
import Addr from './common/Addr'
import Category from './common/Category'
import CheckInput from './common/CheckInput'
import CheckInputStore from './common/CheckInput/store'
import CoverImageUpload from './common/CoverImageUpload'
import CoverVideoUpload from './common/CoverVideoUpload'
import Footer from './common/Footer'
import FormField from './common/FormField'
import PlanField from './common/PlanField'
import Planner from './common/Planner'
import SuccessModal from './common/TipModal'
import { InputPrice, UploadImage, UploadVideo } from './common/UploadField'
import CaseDetail from './components/CaseDetail'
import TagList from './components/TagList'
import Store from './store'
import Style from './style.module.less'

const FormItem = Form.Item
const CheckableTag = Tag.CheckableTag

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}

let isChanged = false
@Form.create({
  onValuesChange: () => {
    isChanged = true
  }
})
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.contentRef = {}
    this.canLeave = false
    this.caseId = ''
  }

  componentDidMount() {
    this.store.initPage(
      this.props.id,
      this.props.propertyId,
      this.props.is_show_kezhao,
      this.props.isFromShuijing,
      this.props.draftId
    )

    // 这里用来实时展示
    let timer = null
    autorun(() => {
      clearTimeout(timer)
      const caseContent = this.store.tempCaseContent.map(
        ({ active, ...rest }) => rest
      )
      timer = setTimeout(() => {
        if (this.store.firstAutoRun) {
          return
        }
        this.props.form.setFieldsValue({
          case_content: caseContent
        })
        if (caseContent.length) {
          this.props.form.validateFields(['case_content'])
        }
      }, 300)
    })

    this.setAsyncRouteLeaveHook()
  }
  componentWillUnmount() {
    CheckInputStore.reset()
    this.canLeave = false
  }

  setAsyncRouteLeaveHook = () => {
    const { router, route } = this.props
    router.setRouteLeaveHook(route, nextLocation => {
      if (this.canLeave) {
        return true
      }
      if (this.store.forceLeave) {
        return true
      }
      const _isChanged = isChanged || this.store.isChanged
      if (_isChanged) {
        this.routerWillLeave(nextLocation)
      }
      return !_isChanged
    })
  }

  routerWillLeave = nextLocation => {
    const { submitting } = this.store
    const { id } = this.props
    if (id) {
      Modal.confirm({
        title: '切换页面发布内容将不会保存，您确定这样操作吗？',
        onOk: () => {
          this.store.setStoreData('needReload', false)
          this.canLeave = true
          hashHistory.push(nextLocation.pathname)
        }
      })
      return
    }
    Modal.confirm({
      title: '是否将该案例保存为草稿?',
      okText: '保存',
      cancelText: '不保存',
      onOk: async () => {
        this.canLeave = true
        this.store.setStoreData('needReload', false)
        await this.handleSubmit('draft', true)
        hashHistory.push(nextLocation.pathname)
      },
      okButtonProps: {
        submitting
      },
      onCancel: async () => {
        this.canLeave = true
        hashHistory.push(nextLocation.pathname)
      }
    })
  }

  // 普通保存的时候有个延时，主要是为了检验敏感词
  // 保存草稿的时候，不需要检验敏感词，直接提交
  handleSubmit = async (type, immediate = false) => {
    if (this.store.submitting) {
      return
    }
    this.store.setStoreData('submitting', true)
    // 取消输入框的焦点
    document.getElementById('root').focus()
    if (immediate) {
      await this.submitFn(type)
    } else {
      setTimeout(() => {
        this.submitFn(type)
      }, 500)
    }
  }

  submitFn = async type => {
    this.store.setStoreData('isChanged', !!isChanged || this.store.isChanged)

    const flag = await this.store.checkActiveTitle()
    if (flag) {
      this.store.setStoreData('submitting', false)
      return
    }

    this.props.form.setFieldsValue({
      case_content: this.store.tempCaseContent.map(
        ({ active, ...rest }) => rest
      )
    })

    isChanged = false

    const shop_title = this.props.form.getFieldValue('title')
    const cityCode = (getMerchantInfo() || {}).city_code
    if (cityCode == -2000 && shop_title && !/测试/.test(shop_title)) {
      Modal.error({
        title: '钓鱼岛商家套餐和案例必须带有“测试”词语'
      })
      this.store.setStoreData('submitting', false)
      return
    }
    if (type == 'draft') {
      const check = await CheckInputStore.checkAll()
      if (check) {
        message.error('请检查敏感词')
        this.store.setStoreData('submitting', false)
        return
      }
      await this.store.submitForm(this.props.form.getFieldsValue(), type)
      this.store.setStoreData('submitting', false)
      return
    }

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        // 检验敏感词
        const check = await CheckInputStore.checkAll()
        if (check) {
          message.error('请检查敏感词')
          this.store.setStoreData('submitting', false)
          return
        }
        const data = await this.store.submitForm(values, type)
        !!data && SuccessModal(data)
      } else {
        this.store.setStoreData('submitting', false)
      }
    })
  }

  validatorCaseContent = (rule, value, callback) => {
    const { property_id } = this.store
    const imgCount = value
      ? value.filter(item => item.type === 'img').length
      : 0
    const videoCount = value
      ? value.filter(item => item.type === 'video').length
      : 0

    // 可上传0-100张图片和0-5个视频
    if (property_id == 8 || property_id == 11) {
      if (!value || value.length === 0) {
        callback('请上传图片或视频')
        return
      }
      if (imgCount < 5 && videoCount == 0) {
        callback('图片至少上传5张')
        return
      }
      if (imgCount > 100) {
        callback('最多上传100张图片')
        return
      }
      if (videoCount > 3) {
        callback('最多上传3个视频')
        return
      }

      callback()
      return
    }

    if (property_id == 14 || property_id == 15) {
      if (!value || value.length === 0) {
        callback('请上传图片')
        return
      }
      if (imgCount > 100) {
        callback('最多上传100张图片')
        return
      }
      if (videoCount > 1) {
        callback('不允许上传视频')
        return
      }

      callback()
      return
    }

    if (
      value &&
      value.every(el => el.type != 'video') &&
      (!value || value.length === 0 || imgCount < 5 || imgCount > 50)
    ) {
      callback('请上传 5~50 张照片')
      return
    }

    callback()
  }

  validatorCoverPath = (rule, value, callback) => {
    const { property_id } = this.store
    if (!value) {
      callback('请上传案例封面')
      return
    }
    if (property_id == 12 || property_id != 13) {
      if (!value.cover_img || !value.cover_img.href) {
        callback('请上传横图')
        return
      }
      if (!value.up_cover_img || !value.up_cover_img.href) {
        callback(isWeddingDressProperty() ? '请上传竖图' : '请上传方图')
        return
      }
    } else {
      if (!value.cover_img || !value.cover_img.href) {
        callback('请上传封面')
      }
    }
    callback()
  }

  checkEmoji = (rule, value, callback) => {
    if (isEmojiCharacter(value)) {
      callback('禁止输入表情符号')
    }
    callback()
  }

  showShuiJing = (is_add_form, isFromShuijing) => {
    const { isPaid, isExpired } = mainStore
    const { is_franchisee } = getMerchantInfo()
    const l = getAuthIdList()
    const hasShuiJingAuth =
      is_franchisee == 1 || (l.includes('-1') || l.includes('2_1_1_3'))
    return (
      hasShuiJingAuth && is_add_form && isPaid && !isExpired && !isFromShuijing
    )
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue, getFieldError },
      isFromShuijing,
      id
    } = this.props
    const {
      tag_list,
      merchant_info,
      show_form,
      form_init,
      properties,
      property_id,
      topWeddingTags = [],
      changeTopWeddingTags,
      selectedTopWeddingTag,
      shuijingCategoryList,
      is_add_form,
      case_detail,
      case_cate,
      submitting,
      hotels,
      onSearchHotel,
      changeTagValue,
      checkImg: { checkCMYK },
      grayTestFlag,
      auditBoxVisible,
      setAuditMediaList,
      setAuditBoxVisible,
      submitAuditHanlder,
      complainSuccess,
      attractionStore
    } = this.store

    const {
      changeCity,
      changeSpotName,
      changeScenicSpot,
      allCity,
      scenicSpot,
      spotId,
      spotName,
      cityName
    } = attractionStore

    // 测试城市 且 目前只适用于 婚策类目 可迁移
    const grayTestHC = grayTestFlag && property_id == 2
    const form_default = toJS(form_init)
    const _show_in_shuijing = getFieldValue('_show_in_shuijing')
      ? getFieldValue('_show_in_shuijing')
      : form_default._show_in_shuijing

    // 如果分类被删除了，就不显示
    const idx = case_cate.findIndex(
      item => item.id == form_default._merchant_category_id
    )
    const _merchant_category_id =
      idx > -1 ? form_default._merchant_category_id : ''

    const top_wedding = !!merchant_info.top_wedding

    const header = [
      <Link to="/localMerchant/case">案例管理</Link>,
      id ? '编辑案例' : '发布案例'
    ]

    return (
      <Spin spinning={!show_form || submitting} style={{ minHeight: '300px' }}>
        <div
          ref={ref => (this.contentRef = ref)}
          className={Style.form}
          style={{ paddingRight: grayTestHC ? 280 : 0, minWidth: 1300 }}
        >
          {/* 最顶部因举报而审核未通过时的通知 */}
          {form_default?.report && (
            <div style={{ padding: '20px 20px 0' }}>
              <Alert
                message={`该案例被举报，正在审核处理中，暂时无法修改案例，如对举报有异议请联系客服 400-159-9090`}
                type="error"
                showIcon
              />
            </div>
          )}
          {grayTestHC && (
            <div className={Style.cardPanel}>
              <div className={Style.ruleCard}>
                <h1>
                  <span>发布提示</span>
                  <a
                    target="_blank"
                    href="https://www.yuque.com/docs/share/962f09e2-e403-459b-b2b1-099306aed4d3?#"
                    rel="noopener noreferrer"
                  >
                    规则说明
                  </a>
                </h1>
                <p>
                  1、请准确填写案例信息，有利于案例在搜索和推荐中露出，错误填写可能面临案例下架或流量损失。
                </p>
                <p>
                  2、严重虚假填写案例信息，如参考价格虚假/抄袭其他商家案例/案例被用户成功举报等行为，将记违规行为，扣除店铺积分和案例质量分。
                </p>
                <p>3、上传案例真实性举证，有助于案例真实性和原创性保护。</p>
              </div>
              <div className={Style.ruleCard}>
                <h1>实例认证案例优先曝光</h1>
                <Carousel autoplay effect="scrollx">
                  <div className="carousel_item">
                    <img src="https://qnm.hunliji.com/Fr5hCz9byA-nwkik_bj1m_RPulIv" />
                    <div className="text">频道页&搜索页</div>
                  </div>
                  <div className="carousel_item">
                    <img src="https://qnm.hunliji.com/FiX6oDV0cIe67-Jd41Uu3WlXGrHJ" />
                    <div className="text">商家主页</div>
                  </div>
                  <div className="carousel_item">
                    <img src="https://qnm.hunliji.com/FpPYRGtEtXLs3SX932nRUR4y-U4w" />
                    <div className="text">案例相册</div>
                  </div>
                </Carousel>
              </div>
            </div>
          )}
          <RouterView
            title="案例基础信息"
            header={header}
            bodyStyle={{ padding: '24px 24px 0' }}
            titleStyle={{ height: 48, padding: '0 24px' }}
            viewStyle={{ margin: '0 20px 4px 20px' }}
          >
            {!!case_detail?.reason &&
              case_detail?.status == 3 && (
                <div style={{ margin: '10px 0 30px 0' }}>
                  <PageHeader
                    type="error"
                    title={`审核未通过原因：${case_detail.reason}`}
                    key="coverPathText"
                  />
                </div>
              )}
            {merchant_info.property_id != '1' &&
              !isSiDaMember() && (
                <FormItem label="案例分类" {...formItemLayout}>
                  {getFieldDecorator('_merchant_category_id', {
                    initialValue: _merchant_category_id
                  })(
                    <Category //案例分类
                      store={this.store}
                    />
                  )}
                </FormItem>
              )}
            {property_id == 6 && (
              <FormItem label="案例类型" {...formItemLayout}>
                {getFieldDecorator('_meal_type', {
                  initialValue: form_default._meal_type,
                  rules: [
                    {
                      required: true,
                      message: '请选择案例类型'
                    }
                  ]
                })(
                  <Radio.Group>
                    <Radio.Button value="1">样片</Radio.Button>
                    <Radio.Button value="2">客照</Radio.Button>
                  </Radio.Group>
                )}
              </FormItem>
            )}

            <FormItem
              label="案例标题"
              {...formItemLayout}
              extra={
                property_id == 6 ? (
                  <div style={{ width: 440, color: '#666' }}>
                    建议样照标题突出样照特点比如“复古风”“新田园主义”，客照标题突出客照真实性比如“张先生&朱女士8月15日客照欣赏”
                  </div>
                ) : (
                  ''
                )
              }
            >
              {getFieldDecorator('title', {
                initialValue: form_default.title || '',
                rules: [
                  {
                    required: true,
                    message: '请输入案例标题'
                  },
                  {
                    min: 12,
                    message: '案例标题字数不能少于12个字'
                  },
                  {
                    max: 24,
                    message: '案例标题字数不能多于24个字'
                  },
                  {
                    validator: this.checkEmoji
                  }
                ]
              })(
                <CheckInput
                  style={{ width: 440 }}
                  placeholder="请输入案例的展示名称，建议名称总长度在12-24字"
                  maxLength={24}
                  suffix={`${getFieldValue('title').length}/24`}
                  getfielderror={getFieldError}
                  type={1}
                />
              )}
            </FormItem>
            {property_id == 2 && (
              <FormItem
                label="参考价格"
                {...formItemLayout}
                extra="参考价格包含方案策划、现场布置、服务人员 (如管家、督导，不含四大金刚) 等"
              >
                {getFieldDecorator('caseReference', {
                  initialValue: form_default.caseReference,
                  rules: [
                    {
                      required: true,
                      message: '请输入参考价格'
                    },
                    {
                      validator: (rule, value) => {
                        if (value % 1 > 0) {
                          return Promise.reject('参考价格不可输入小数')
                        } else {
                          return Promise.resolve()
                        }
                      }
                    }
                  ]
                })(<InputPrice />)}
              </FormItem>
            )}
            {property_id == 2 && (
              <FormItem label="婚礼日期" {...formItemLayout}>
                {getFieldDecorator('wedding_date', {
                  initialValue: form_default.wedding_date,
                  rules: [
                    {
                      required: true,
                      message: '请选择婚礼日期'
                    }
                  ]
                })(<DatePicker style={{ width: 240 }} />)}
              </FormItem>
            )}
            {property_id == 2 && (
              <Addr
                getFieldDecorator={getFieldDecorator}
                setFieldsValue={setFieldsValue}
                hotels={hotels}
                formItemLayout={formItemLayout}
                onSearchHotel={onSearchHotel}
                form_default={form_default}
                getFieldError={getFieldError}
              />
            )}
            {/* 婚纱礼服12 可以上传横图和竖图 */}
            <FormItem
              label="案例封面"
              className={Style.coverPath}
              {...formItemLayout}
            >
              {getFieldDecorator('cover_path', {
                initialValue: form_default.cover_path,
                rules: [
                  {
                    required: true,
                    message: '请上传封面图'
                  },
                  {
                    validator: this.validatorCoverPath
                  }
                ]
              })(
                <CoverImageUpload
                  isMutile={property_id != 13 || property_id == 12}
                  checkCMYK={checkCMYK}
                />
              )}
            </FormItem>
            <FormItem label="头图视频" {...formItemLayout}>
              {getFieldDecorator('cover_video', {
                initialValue: form_default.cover_video
              })(<CoverVideoUpload />)}
            </FormItem>

            {property_id == 6 &&
              top_wedding && (
                <FormItem label="摄影师" {...formItemLayout}>
                  {getFieldDecorator('person_id', {
                    initialValue: form_default.person_id || undefined
                  })(<Planner type="photographt" />)}
                </FormItem>
              )}

            {property_id == 6 && (
              <>
                <FormItem label="拍摄城市" {...formItemLayout}>
                  {getFieldDecorator('cityname', {
                    initialValue: toJS(cityName)
                  })(
                    <Cascader
                      showSearch={{
                        filter: (inputValue, path, names) => {
                          return path.some(function(option) {
                            return option[names.label]?.indexOf(inputValue) > -1
                          })
                        }
                      }}
                      options={toJS(allCity)}
                      placeholder="请选择拍摄城市"
                      onChange={changeCity(setFieldsValue)}
                    />
                  )}
                </FormItem>

                {(!!cityName.length || (this.props.id && spotId == '0')) && (
                  <FormItem
                    label="拍摄景点"
                    {...formItemLayout}
                    style={{ marginBottom: 0 }}
                  >
                    <div className={Style.box}>
                      <div className={Style.boxLeft}>
                        <FormItem noStyle>
                          {getFieldDecorator('spotId', {
                            initialValue: spotId
                          })(
                            <Select
                              showSearch
                              allowClear
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              placeholder="请选择拍摄景点"
                              style={{ width: 200 }}
                              onChange={changeScenicSpot(setFieldsValue)}
                            >
                              {scenicSpot.map(({ id, name }) => (
                                <Select.Option key={id} value={id}>
                                  {name}
                                </Select.Option>
                              ))}
                              <Select.Option value={0}>
                                自定义景点
                              </Select.Option>
                            </Select>
                          )}
                        </FormItem>
                      </div>

                      <div className={Style.boxLeft} style={{ marginLeft: 10 }}>
                        {spotId == '0' && (
                          <FormItem
                            {...formItemLayout}
                            noStyle
                            style={{ marginBottom: 0 }}
                          >
                            {getFieldDecorator('spotName', {
                              initialValue: spotName
                            })(
                              <Input
                                placeholder="请输入拍摄的景点"
                                style={{ width: 440 }}
                                onChange={changeSpotName}
                                maxLength={24}
                                suffix={`${spotName.length}/24`}
                              />
                            )}
                          </FormItem>
                        )}
                      </div>
                    </div>
                  </FormItem>
                )}
              </>
            )}

            {property_id == 2 ? (
              <PlanField
                getFieldDecorator={getFieldDecorator}
                setFieldsValue={setFieldsValue}
                hotels={hotels}
                formItemLayout={formItemLayout}
                onSearchHotel={onSearchHotel}
                form_default={form_default}
                getFieldError={getFieldError}
              />
            ) : (
              <FormField
                propertyId={property_id}
                getFieldDecorator={getFieldDecorator}
                formItemLayout={formItemLayout}
                form_default={form_default}
                getFieldError={getFieldError}
                getFieldValue={getFieldValue}
              />
            )}

            {!!getMerchantInfo().is_franchisee &&
              getMerchantInfo().is_franchisee != 0 && (
                <FormItem label="案例类目" {...formItemLayout}>
                  {getFieldDecorator('property_id', {
                    initialValue: form_default.property_id,
                    rules: [
                      {
                        required: true,
                        message: '请选择案例类目'
                      }
                    ]
                  })(
                    <Select
                      placeholder="案例类目"
                      style={{ width: 200 }}
                      onChange={this.store.setPropertyId}
                      getPopupContainer={() => this.contentRef}
                    >
                      <Select.Option value="">请选择案例类目</Select.Option>
                      {properties &&
                        properties.map((item, index) => {
                          return item.id != 1 ? (
                            <Select.Option value={item.id} key={index}>
                              {item.name}
                            </Select.Option>
                          ) : null
                        })}
                    </Select>
                  )}
                </FormItem>
              )}
            {/* 只有在门店开通水镜，同时是新建婚礼纪案例的情况下，已经支付，不是来自水镜，才显示以下选项 */}
            {this.showShuiJing(is_add_form, isFromShuijing) && (
              <>
                <FormItem {...formItemLayout} label="展示到水镜">
                  {getFieldDecorator('_show_in_shuijing', {
                    initialValue: form_default._show_in_shuijing
                  })(
                    <Radio.Group>
                      <Radio value="1">是</Radio>
                      <Radio value="0">否</Radio>
                    </Radio.Group>
                  )}
                </FormItem>
                {_show_in_shuijing === '1' && (
                  <FormItem label="水镜中展示位置" {...formItemLayout}>
                    {getFieldDecorator('_mirror_category_id', {
                      initialValue: form_default._mirror_category_id,
                      rules: [
                        { required: true, message: '添加至水镜的展示位置' }
                      ]
                    })(
                      <TreeSelect
                        multiple
                        allowClear
                        treeData={toJS(shuijingCategoryList)}
                        style={{ width: 440 }}
                        placeholder="请选择展示位置"
                        treeDefaultExpandAll
                      />
                    )}
                  </FormItem>
                )}
              </>
            )}

            {top_wedding && (
              <FormItem
                className={'tags'}
                label={'高定标签'}
                {...formItemLayout}
              >
                {topWeddingTags.map(({ id, name }, i) => {
                  return (
                    <CheckableTag
                      key={i}
                      checked={(selectedTopWeddingTag || []).some(
                        item => item == id
                      )}
                      className="border"
                      onChange={changeTopWeddingTags(id)}
                    >
                      {name}
                    </CheckableTag>
                  )
                })}
              </FormItem>
            )}
          </RouterView>
          <RouterView
            domId="main-content1"
            title="案例详细信息"
            bodyStyle={{ padding: '24px 24px 20px 24px' }}
            titleStyle={{ height: 48, padding: '0 24px' }}
            viewStyle={{ margin: '0 20px 4px 20px' }}
          >
            <FormItem className="wrap" {...formItemLayout}>
              {getFieldDecorator('case_content', {
                initialValue: form_default.case_content,
                rules: [
                  {
                    required: true,
                    validator: this.validatorCaseContent
                  }
                ]
              })(
                <CaseDetail
                  store={this.store}
                  _meal_type={getFieldValue('_meal_type')}
                  onSubmit={case_content => () => {
                    setFieldsValue({
                      case_content
                    })
                    this.store.closeCaseContentModal()
                  }}
                />
              )}
            </FormItem>
          </RouterView>
          <TagList
            tag_list={tag_list}
            formItemLayout={formItemLayout}
            changeTagValue={changeTagValue}
          />
          {grayTestHC && ( // xin_tian屏蔽
            <RouterView
              domId="main-content3"
              title={
                <div>
                  实例认证（选填）
                  {form_default.certified == 1 && (
                    <span className={Style.passLabel}>认证通过</span>
                  )}
                </div>
              }
              bodyStyle={{ padding: '24px' }}
              titleStyle={{ height: 48, padding: '0 24px' }}
            >
              <div style={{ padding: '0 0 44px 0' }}>
                <PageHeader
                  style={{ color: '#333', marginBottom: 40 }}
                  title="通过实例认证，有助于案例真实性和原创性保护。为保护商家利益，平台会严格审核认证资料，若认证资料涉嫌造假，将取消实例认证并受到惩罚。举证资料只用于平台审核，不会在婚礼纪 app 上展示。"
                />
                <FormItem label="原片/视频" {...formItemLayout}>
                  {getFieldDecorator('verify_origin', {
                    initialValue: form_default.verify_origin,
                    rules: [
                      {
                        required: false
                        // message: '请上传婚礼现场原片或视频'
                      }
                    ]
                  })(<UploadVideo />)}
                </FormItem>
                <FormItem label="其他举证" {...formItemLayout}>
                  {getFieldDecorator('verify_others', {
                    initialValue: form_default.verify_others,
                    rules: [
                      {
                        required: false
                        // message: '请上传举证图片'
                      }
                    ]
                  })(<UploadImage />)}
                </FormItem>
              </div>
            </RouterView>
          )}
          <Footer
            complainSuccess={complainSuccess}
            handleSubmit={this.handleSubmit}
            store={this.store}
            isDraft={!!this.props.draftId}
            id={this.props.id}
            draftId={this.props.draftId}
            isReport={form_default.report}
            unCertified={[0, 1, 3].includes(
              case_detail?.appeal_proof?.proof?.appeal_status
            )}
          />
          <Modal
            title="发起申诉"
            visible={auditBoxVisible}
            onOk={() => submitAuditHanlder(this.props.id)}
            onCancel={() => setAuditBoxVisible(false)}
            okText="发起申诉"
            width={640}
            maskClosable={false}
            keyboard={false}
          >
            <p style={{ fontWeight: 'bold' }}>
              请根据审核未通过原因上传真实可信的举证：
            </p>
            <p>1.参考价格与案例效果不符：可上传收款截图、服务合同等；</p>
            <p>
              2.案例图片涉嫌抄袭/盗图/使用网图：可上传婚礼现场原片、视频、设计手稿等；
            </p>
            <p>3.图片大小不能超过 10 MB，视频大小不能超过 500 MB。</p>
            <div className={Style.auditList}>
              <Upload
                multiple
                accept="image/*,video/*"
                upText="点击上传凭证"
                max={10}
                onChange={val => {
                  setAuditMediaList(val)
                }}
                beforeUpload={(file, fileList) => {
                  if (fileList.length > 10) {
                    message.error({
                      content: '上传数量不得超过10个',
                      key: 'videoNum'
                    })
                    return false
                  } else {
                    if (file.type.includes('video')) {
                      if (file.size > 1024 * 1024 * 500) {
                        message.error({
                          content: '视频大小不能超过500M',
                          key: 'videoSize'
                        })
                        return false
                      } else {
                        return true
                      }
                    } else {
                      if (file.size > 1024 * 1024 * 10) {
                        message.error({
                          content: '图片大小不能超过10M',
                          key: 'picSize'
                        })
                        return false
                      } else {
                        return true
                      }
                    }
                  }
                }}
              />
            </div>
          </Modal>
          {/* 被举报遮罩 */}
          {form_default?.report && <div className={Style.preventMask} />}
        </div>
      </Spin>
    )
  }
}
